<template>
  <div>
    <div class="" style="display:block">
      <div>
        <el-form :inline="true"  class="demo-form-inline">
           <el-form-item>
             <ul class="DataTime_box">
               <li v-for="(item,index) in DataTime" :key="index" class="DataTime_item_Box" @click="DataTimecli(item,index)">
                 <span :class="DataTimeIndex===index?'DataTime_item_act':'DataTime_item'">{{item.name}}</span>
                </li>
             </ul>
          </el-form-item>
          <el-form-item >
            <span style="margin-right:11px;margin-left:20px">时间范围:</span>
             <el-date-picker
              v-model="ruleForm.time"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="DatePicker">
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="SubmitBleen" style="padding-left:12px">
            <el-button  @click="onReset">重置</el-button>
            <el-button type="primary" @click="onSubmit('TodayapickChange')">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    SubmitBleen:{
      default:false
    }
  },
  data(){
    return{
      pickerOptions: { //限制选择当前时间之后的方法
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;  //如果没有后面的-8.64e6就是不可以选择今天的 
        }
      },
      DataTime:[ //日期选择列表
        {
          name:"今天",
        },
        {
          name:"本周",
        },
        {
          name:"本月",
        },
      ],
      DataTimeIndex:0,//当前选中的日期
      ruleForm:{ //筛选条件的对象
        prolei:"",//商品的名称
        time:"",
        StartTime:"",
        EndTime:"",
      },
    }
  },
  created(){

  },
  mounted(){
    let act={
      name:"今天",
    }
    this.DataTimecli(act,0)
  },
  computed:{

  },
  methods:{
    getTimeNow(){ //获取当前时间的格式化
      var endData=new Date()
      var month = parseInt(endData.getMonth() + 1);
      var day = endData.getDate();
      var hous=endData.getHours()
      var minu=endData.getSeconds()
      var fend=endData.getMinutes()
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        if (hous < 10) {
          hous = "0" + hous;
        }
        if (fend < 10) {
          fend = "0" + fend;
        }
        this.ruleForm.EndTime=endData.getFullYear() + "-" + month + "-" + day+" "+hous+":"+fend+":"+minu
    },
    formatDate(date) {  //获取当前时间距离本周一的时间
          var myyear = date.getFullYear();
          var mymonth = date.getMonth() + 1;
          var myweekday = date.getDate();
          if (mymonth < 10) {
              mymonth = "0" + mymonth;
          }
          if (myweekday < 10) {
              myweekday = "0" + myweekday;
          }
          return (myyear + "-" + mymonth + "-" + myweekday+" "+"00:00:00");
      },
    DataTimecli(item,index){ //获取当前时间距离本月第一天的时间
      
      switch (item.name) {
        case "今天":
          var endData=new Date()
          var Nowmonth = parseInt(endData.getMonth() + 1);
          var Nowday = endData.getDate();
            if (Nowmonth < 10) {
              Nowmonth = "0" + Nowmonth;
            }
            if (Nowday < 10) {
              Nowday = "0" + Nowday;
            }
            this.ruleForm.StartTime=endData.getFullYear() + "-" +Nowmonth + "-" + Nowday+" "+"00:00:00"
            this.getTimeNow()
          break;
        case "本周":
          var now = new Date();
          var nowTime = now.getTime();
          var daytime = now.getDay() || 7; // 不加 || 7.周末会变成下周一
          var oneDayTime = 24 * 60 * 60 * 1000;
          var MondayTime = nowTime - (daytime - 1) * oneDayTime; //显示周一
          this.ruleForm.StartTime=this.formatDate(new Date(MondayTime))
          this.getTimeNow()
          break;
        case "本月":
          var date = new Date();
              date.setDate(1);
          var month = parseInt(date.getMonth() + 1);
          var daynow = date.getDate();
            if (month < 10) {
              month = "0" + month;
            }
            if (daynow < 10) {
              daynow = "0" + daynow;
            }
            this.ruleForm.StartTime=date.getFullYear() + "-" + month + "-" + daynow+" "+"00:00:00"
            this.getTimeNow()
          break;
        default:
          break;
      }
      if(!this.SubmitBleen){
        this.$emit("GetArrayList",this.ruleForm)
        // this.onSubmit('GetArrayList')
      }
      this.DataTimeIndex=index
    },
    DatePicker(event){  //时间选择器确定事件
      console.log('event :>> ', event);
      if(event){
        this.ruleForm.StartTime=event[0]
        this.ruleForm.EndTime=event[1]
        if(!this.SubmitBleen){
          this.$emit("GetArrayList",this.ruleForm)
        }
      }else{
        let act={
          name:"今天",
        }
        this.DataTimecli(act,0)
        // this.$emit("GetArrayList",this.ruleForm)

      }
    },
    onReset(){//点击重置事件
      this.ruleForm={}
      this.DataTimeIndex=0
      this.$emit("Blanking",true)
    },
    onSubmit(clickname){ //点击查询事件
      this.$emit(clickname,this.ruleForm)
      // console.log(this.ruleForm)
    },
  }
}
</script>
<style lang="scss" scoped>
ul,li{ 
  padding:0;
  margin:0;
  list-style:none;
}
.main {
  min-width: 1200px;
  margin: 20px;
  background: #fff;
  padding: 30px;

}
.el-form-item{
  margin: 0;
}
.title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 18px;
    color: #333;
    width: 100%;
    padding: 15px 32px;
}
.demo-form-inline{
  width: 100%;
}
.DataTime_box{
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .DataTime_item_Box{
    margin: 0 20px;
    flex: 1;
    text-align: center;
    position: relative;
    .DataTime_item_act{
      &:after{
        text-align: center;
        position: absolute;
        top: 50px;
        left:25%;
        transform: translateX(-25%);
        bottom:0;
        width: 29px;
        height: 2px;
        background-color: #2448FF;
        content:"";
      }
      color: #2448FF;
    }
    .DataTime_item{
      flex: 1;
      text-align: center;
    }
  }
  
}
</style>